import { Actions, Subjects, UISubjects, type CompleteRuleSet } from './abilityTypes'

export const MEMBER_RULES = {
  [Subjects.USER]: () => [],
  [Subjects.USER_DETAIL]: () => [],
  [Subjects.ATTENDANCE]: () => [{ actions: [Actions.READ, Actions.WRITE] }],
  [Subjects.CHANGE_MY_PASSWORD]: () => [{ actions: [Actions.WRITE] }],
  [Subjects.PROJECT]: () => [],
  [Subjects.PROJECT_CREATE]: () => [],
  [Subjects.PROJECT_USER]: () => [],
  [Subjects.PROJECT_SALES_COST]: () => [],
  [Subjects.USER_PROJECT]: () => [],
  [Subjects.ADD_PROJECT]: () => [],
  [Subjects.RESOURCE_PLAN]: () => [],
  [Subjects.ASSIGN_BY_VOLUMED]: () => [],
  [Subjects.VOLUMED_ASSIGN]: () => [],
  [Subjects.CLIENT]: () => [],
  [Subjects.DEPARTMENT]: () => [],
  [Subjects.PARTNER]: () => [],
  [Subjects.JOB_SKILL]: () => [],
  [Subjects.JOB_TITLE]: () => [],
  [Subjects.HOLIDAY]: () => [],
  [Subjects.JOB]: () => [],
  [Subjects.CUSTOM_FIELD]: () => [],
  [Subjects.SETTING]: () => [],
  [UISubjects.PROJECT_LIST_COPY_BUTTON]: () => [],
  [UISubjects.PROJECT_LIST_DELETE_BUTTON]: () => [],
  [UISubjects.RESOURCE_PLAN_ADD_USER_BUTTON]: () => [],
  [UISubjects.RESOURCE_PLAN_PROJECT_PLAN_TABLE_EDIT_ASSIGN]: () => [],
  [UISubjects.RESOURCE_PLAN_PROJECT_PLAN_TABLE_ADD_BUTTONS]: () => [],
  [UISubjects.RESOURCE_PLAN_PROJECT_PLAN_TABLE_EDIT_ASSIGN_ICON]: () => [],
  [UISubjects.PROJECT_SALES_COST_EDIT_BUTTON]: () => [],
  [UISubjects.PROJECT_SALES_COST_ADD_COST_BUTTON]: () => [],
  [UISubjects.USER_PROJECT_EDIT_ASSIGN]: () => [],
  [UISubjects.USER_PROJECT_EDIT_ASSIGN_ICON]: () => [],
  [UISubjects.PROJECT_USER_ASSIGN_USER]: () => [],
  [UISubjects.PROJECT_USER_EDIT_ASSIGN_ICON]: () => [],
  [UISubjects.ADD_PROJECT_EDIT_ASSIGN]: () => []
} satisfies CompleteRuleSet
